import { FC } from 'react';
import CopyText, { CopyTextProps } from './copyText';
import CopySync, { CopySyncProps } from './copySync';

export type ICopyTextComponent = FC<CopyTextProps> & {
  Sync: FC<CopySyncProps>;
};

/** 文字复制 */
const TransCopyText = CopyText as ICopyTextComponent;
TransCopyText.Sync = CopySync;

export default TransCopyText;
